// @flow
import Pagination from 'rc-pagination';
import styled from 'styled-components';


const RcPagination = styled(Pagination)`
${(props) => `
list-style: none;
display: inline-flex;
font-size: 12px;

.rc-pagination {
  user-select: none;
  padding: 0;

  > li {
    list-style: none;
  }

  &-total-text {
    float: left;
    height: 30px;
    line-height: 30px;
    list-style: none;
    padding: 0;
    margin: 0 8px 0 0;
  }

  &:after {
    content: ' ';
    display: block;
    height: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }

  &-item {
    cursor: pointer;
    border-radius: 4px;
    height: 18px;
    line-height: 19px;
    text-align: center;
    list-style: none;
    float: left;
    padding: 0 0;

    a {
      align-self: center;
      text-decoration: none;
      color: #666;
      
      &::after not(.) {
        content: '-';
        margin-left: 4px;
      }
    }

    &:focus { outline: none; }

    &-active {
      font-weight: 800;
    }
  }

  &-jump-prev, &-jump-next {
    cursor: pointer;
    border-radius: 4px;
    min-width: 18px;
    height: 18px;
    line-height: 19px;
    text-align: center;
    list-style: none;
    float: left;
    margin-right: 4px;
    margin-left: 4px;
    padding: 0 0;

    &:focus { outline: none; }
  }
}
`}
`;

export default RcPagination;
